import { useCallback } from 'react';
import logger from '../utils/biLogger';
import { marketplaceHeaderClientGenericClick } from '@wix/bi-logger-marketplace/v2';

interface MarketplaceHeaderClickProps {
  clickType: string;
  click_data?: string;
}

export function useMarketplaceHeaderBi(pageName: string) {
  const report = useCallback(
    ({ clickType, click_data }: MarketplaceHeaderClickProps) =>
      logger.report(
        marketplaceHeaderClientGenericClick({
          clickType,
          pageName,
          click_data,
        }),
      ),
    [pageName],
  );

  return report;
}
